import { Injectable } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { ShareStatistics } from "../../domain/model/share-statistics";

/**
 * Web service used to get match detail.
 */
@Injectable({
  providedIn: "root",
})
export class MatchShareStatisticsWS {
  constructor(private handler: BaseHandler) {}

  execute(matchId: string, token: string): Observable<ShareStatistics> {
    const parameters = new HandlerBuilder()
      .setUrl(ApiUrls.MATCH_SHARE_STATISTICS_ENDPOINT(matchId))
      .setMethod(HttpMethod.post)
      .setAuthorization(new TokenAuthorization(token))
      .build();
    return this.handler.execute(parameters).pipe(
      map((response) => {
        return response;
      })
    );
  }
}
